import { Link, useSearchParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { useSeo } from "../lib/seo";
import { PageHero, EmptyState } from "../components/shop/Common";
import { ProductListing } from "../components/shop/ProductListing";

const TITLES = { "t-shirt": "Vacation T-Shirts", hoodie: "Vacation Hoodies", "tank-top": "Vacation Tank Tops", hat: "Vacation Hats" };

export default function Shop() {
  const [sp] = useSearchParams();
  const type = sp.get("type") || undefined;
  const { data, loading } = useApi("/products", {});
  const title = TITLES[type] || "Shop All Vacation Apparel";
  useSeo({ title, description: "Shop funny vacation shirts, destination tees, vacation hats, hoodies and tank tops. Printed on demand for your next trip." });
  return (
    <>
      <PageHero eyebrow="Shop all" title={title} subtitle="Every design, every destination." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <ProductListing
          key={type || "all"}
          products={data}
          loading={loading}
          initialType={type}
          empty={
            <EmptyState title="Our first collection is almost here" text="We're putting the finishing touches on our original vacation designs." testid="shop-empty">
              <Link to="/destinations" className="rounded-full bg-sun px-6 py-3 font-bold text-navy">Browse destinations</Link>
            </EmptyState>
          }
        />
      </section>
    </>
  );
}
